import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { fontStyle } from '../../../../theme/helpers/fontStyle';

export const $ToastTitle = styled.div`
  font-weight: bold;
  ${fontStyle('base')};
  margin-bottom: ${spacing('xs')};
`;
